import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  ModalBaseWrapper,
  ModalOverlayBaseWrapper,
  ModalSectionBaseWrapper
} from './styled'

class ModalSectionBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      padding,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingHorizontal,
      paddingVertical,
      paddingMobileHorizontal,
      paddingMobileVertical,
      bgColor,
      borderTopWidth,
      borderTopStyle,
      borderTopColor,
      borderBottomWidth,
      borderBottomStyle,
      borderBottomColor,
      borderTopRightRadius,
      borderTopLeftRadius,
      borderBottomRightRadius,
      borderBottomLeftRadius,
      borderRadius,
      breakpointMobile
    } = this.props

    return (
      <ModalSectionBaseWrapper
        className={ClassNames(
          'modal-section-base',
          // Option
          className
        )}
        theme={{
          // Default
          padding,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          paddingHorizontal,
          paddingVertical,
          paddingMobileVertical,
          paddingMobileHorizontal,
          bgColor,
          borderTopWidth,
          borderTopStyle,
          borderTopColor,
          borderBottomWidth,
          borderBottomStyle,
          borderBottomColor,
          borderTopRightRadius,
          borderTopLeftRadius,
          borderBottomRightRadius,
          borderBottomLeftRadius,
          borderRadius,
          breakpointMobile
        }}
      >
        {children}
      </ModalSectionBaseWrapper>
    )
  }

  static defaultProps = {
    bgColor: VARIABLES.COLORS.WHITE
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingHorizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingVertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingMobileHorizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paddingMobileVertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bgColor: PropTypes.string,
    borderTopWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderTopStyle: PropTypes.string,
    borderTopColor: PropTypes.string,
    borderBottomWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderBottomStyle: PropTypes.string,
    borderBottomColor: PropTypes.string,
    borderTopRightRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderTopLeftRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderBottomRightRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderBottomLeftRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    breakpointMobile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /**
    * Additional Text, HTML, Component
    */
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}

export class ModalBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      open,
      transition,
      transformStart,
      transformEnd,
      width,
      spacing,
      spacingTop,
      spacingRight,
      spacingBottom,
      spacingLeft,
      spacingHorizontal,
      spacingVertical,
      overlayColor,
      onClickClose,
      buttonClose,
      buttonCloseSpacingTop,
      buttonCloseSpacingRight,
      enableOverlayClose
    } = this.props

    return (
      <React.Fragment>
        <ModalBaseWrapper
          className={ClassNames(
            'modal-base',
            { 'is-open': open },
            // Option
            className
          )}
          theme={{
            // Default
            transition,
            transformStart,
            transformEnd,
            width,
            spacing,
            spacingTop,
            spacingRight,
            spacingBottom,
            spacingLeft,
            spacingHorizontal,
            spacingVertical,
            buttonCloseSpacingTop,
            buttonCloseSpacingRight
          }}
        >
          <div className='modal-container-base'
            theme={{
              transition
            }}
          >
            <div className='modal-button-close-base'
              onClick={onClickClose}
              onKeyDown={() => { }}
              tabIndex={0}
              role='button'
            >
              {buttonClose}
            </div>
            {children}
          </div>
          {/* Use 'onClickClose' props instead 'modal-overlay' because it is under 'modal' */}
          {enableOverlayClose &&
            <div className='modal-overlay-clickable-area-base'
              tabIndex={0}
              onClick={onClickClose}
              onKeyDown={() => { }}
              role='button'
            />
          }
        </ModalBaseWrapper>
        {/* Separate out from 'modal' becuase z-index bug in ios webview */}
        <ModalOverlayBaseWrapper className={ClassNames(
          'modal-overlay-base',
          { 'is-open': open }
        )}
          theme={{
            transition,
            overlayColor
          }}
        />
      </React.Fragment>
    )
  }

  static Section = ModalSectionBase

  static defaultProps = {
    enableOverlayClose: true
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    open: PropTypes.bool,
    transition: PropTypes.string,
    transformStart: PropTypes.string,
    transformEnd: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingRight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingHorizontal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    spacingVertical: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    overlayColor: PropTypes.string,
    onClickClose: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    buttonClose: PropTypes.string,
    buttonCloseSpacingTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    buttonCloseSpacingRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    enableOverlayClose: PropTypes.bool,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
